import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { ListCollapseIcon, Settings2Icon, Share2Icon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import ChackInProgressIcon from '@/shared/components/icons/CheckInProgressIcon'
import {
	PageNavigatorHost,
	PageNavigatorProvider,
} from '@/shared/components/PageNavigator'
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbList,
	BreadcrumbPage,
} from '@/shared/components/ui/breadcrumb'
import { Button } from '@/shared/components/ui/button'
import { Header, Layout } from '@/shared/components/ui/layout'
import { Separator } from '@/shared/components/ui/separator'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'

function AnchorManagementHost() {
	const { t } = useTranslation()

	return (
		<PageNavigatorProvider>
			<Layout>
				<Header className='h-11 items-center border-b px-4 py-2'>
					<Share2Icon className='size-4' />
					<Separator orientation='vertical' className='mx-2 h-5' />
					<Breadcrumb className='mr-2 text-sm'>
						<BreadcrumbList>
							<BreadcrumbItem>
								<BreadcrumbPage>
									{t('app.anchoring_management.page.title')}
								</BreadcrumbPage>
							</BreadcrumbItem>
						</BreadcrumbList>
					</Breadcrumb>
					<Separator orientation='vertical' className='mx-2 h-5' />
					<div className='flex items-center gap-1'>
						<div className='ml-2 flex items-center gap-1'>
							<Tooltip>
								<TooltipTrigger asChild>
									<Button size='icon' variant='ghost' asChild>
										<Link
											to='/p/anchor-management/assortment'
											className='data-[status=active]:bg-muted dark:data-[status=active]:bg-muted'
										>
											<ListCollapseIcon className='size-4' />
										</Link>
									</Button>
								</TooltipTrigger>
								<TooltipContent>
									{t('app.anchoring_management.page.title')}
								</TooltipContent>
							</Tooltip>
							<Tooltip>
								<TooltipTrigger asChild>
									<Button size='icon' variant='ghost' asChild>
										<Link
											to='/p/anchor-management/anchor-strategy'
											className='data-[status=active]:bg-muted dark:data-[status=active]:bg-muted'
										>
											<Settings2Icon className='size-4' />
										</Link>
									</Button>
								</TooltipTrigger>
								<TooltipContent>
									{t('anchoring_management.strategy_page.title')}
								</TooltipContent>
							</Tooltip>
							<Tooltip>
								<TooltipTrigger asChild>
									<Button size='icon' variant='ghost' asChild>
										<Link
											to='/p/anchor-management/anchor-approval'
											className='data-[status=active]:bg-muted dark:data-[status=active]:bg-muted'
										>
											<ChackInProgressIcon className='size-4' />
										</Link>
									</Button>
								</TooltipTrigger>
								<TooltipContent>
									{t('anchoring_management.approval_page.title')}
								</TooltipContent>
							</Tooltip>
						</div>
					</div>
					<div className='ml-auto'>
						<PageNavigatorHost />
					</div>
				</Header>
				<Outlet />
			</Layout>
		</PageNavigatorProvider>
	)
}

export const Route = createFileRoute('/_app/p/anchor-management')({
	component: AnchorManagementHost,
})
